import SectionMessage from '@atlaskit/section-message';
import { creditPolicyResponse } from '@atlassian/cssxp-types-quote';
import { REASON_CODES } from '@css-xp/ppc-constants';
import { getCreditUsageUiUrl } from '@css-xp/ppc-navigation-partner-support-utils';
import React from 'react';

export const TermPaymentValidationError = ({
  financePolicyResponse,
  transactionAccountId,
}: {
  financePolicyResponse: creditPolicyResponse;
  transactionAccountId: string;
}) => {
  const { reasonCode, reasonDescription, title } = financePolicyResponse;
  if (reasonCode === REASON_CODES.NET14__MAX_LIMIT_CHECK) {
    return (
      <SectionMessage title={title} appearance="error">
        <div>
          We are unable to process your payment method due to insufficient credit limit. You can always request
          additional credit limits or pay on account.
        </div>
        <div>
          <a href={getCreditUsageUiUrl(transactionAccountId)} target="_blank">
            Manage
          </a>
        </div>
      </SectionMessage>
    );
  }

  return (
    <SectionMessage title={title} appearance="error">
      {reasonDescription}
    </SectionMessage>
  );
};
